// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3pRoU","label":"Labeled_label__1ND1X","divider":"Labeled_divider__JLCSz"};